// import React, { useState } from 'react';

// const Register = () => {
//   const [selectedRole, setSelectedRole] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState({});
//   const [patientData, setPatientData] = useState({First: '', Middle: '', Last: '', Email: '', Mobile: '', Password: '', ConfirmPassword: ''});
//   const [doctorData, setDoctorData] = useState({ClinicName: '', LicenseNumber: '', Education: '', Email: '', First: '', Last: '', Locality: '', Mobile: '', Speciality: '', Password: '', ConfirmPassword: ''});
//   const [hospitalData, setHospitalData] = useState({HospitalName: '', RegistrationNumber: '', Email: '', Address: '', City: '', State: '', Mobile: '', Password: '', ConfirmPassword: ''});

//   const validateName = (name) => /^[a-zA-Z\s]*$/.test(name.trim());
//   const validateEmail = (email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
//   const validatePassword = (password) => /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(password);
//   const validateMobile = (mobile) => /^[6-9]\d{9}$/.test(mobile);

//   const handleSubmit = async (role) => {
//     let data = role === 'patient' ? patientData : role === 'doctor' ? doctorData : hospitalData;
    
//     // Validation
//     if (role === 'patient') {
//       if (!data.First || !data.Middle || !data.Last) {
//         alert('All name fields are required');
//         return;
//       }
//       if (!validateName(data.First) || !validateName(data.Middle) || !validateName(data.Last)) {
//         alert('Names should not contain numbers or special characters');
//         return;
//       }
//     }
    
//     if (!validateEmail(data.Email)) {
//       alert('Please enter a valid email address');
//       return;
//     }
    
//     if (!validateMobile(data.Mobile)) {
//       alert('Please enter a valid 10-digit mobile number starting with 6-9');
//       return;
//     }
    
//     if (role === 'patient' && !validatePassword(data.Password)) {
//       alert('Password must be at least 8 characters with one letter, number, and special character');
//       return;
//     }
    
//     if (data.Password !== data.ConfirmPassword) {
//       alert('Passwords do not match');
//       return;
//     }

//     setLoading(true);
    
//     try {
//       // Import Firebase functions (you need to add these imports at the top of your component)
//       const { getAuth, createUserWithEmailAndPassword } = await import('firebase/auth');
//       const { getDatabase, ref, set } = await import('firebase/database');
//       const { app } = await import('../../../config/Firebase/firebase.config');
      
//       const auth = getAuth(app);
//       const fireDB = getDatabase(app);
      
//       const userCredential = await createUserWithEmailAndPassword(auth, data.Email, data.Password);
//       const uid = userCredential.user.uid;

//       if (role === 'patient') {
//         await set(ref(fireDB, `users/${uid}`), {
//           First: data.First,
//           Middle: data.Middle,
//           Last: data.Last,
//           Email: data.Email,
//           Mobile: data.Mobile,
//           uid: uid,
//           role: 'patient',
//           createdAt: new Date().toISOString(),
//         });
//       } else if (role === 'doctor') {
//         await set(ref(fireDB, `doctor/${uid}`), {
//           ClinicName: data.ClinicName,
//           LicenseNumber: data.LicenseNumber,
//           Education: data.Education,
//           Email: data.Email,
//           First: data.First,
//           Last: data.Last,
//           Locality: data.Locality,
//           Mobile: data.Mobile,
//           Speciality: data.Speciality,
//           uid: uid,
//           role: 'doctor',
//           createdAt: new Date().toISOString(),
//         });
//       } else if (role === 'hospital') {
//         await set(ref(fireDB, `hospitals/${uid}`), {
//           HospitalName: data.HospitalName,
//           RegistrationNumber: data.RegistrationNumber,
//           Email: data.Email,
//           Address: data.Address,
//           City: data.City,
//           State: data.State,
//           Mobile: data.Mobile,
//           uid: uid,
//           role: 'hospital',
//           createdAt: new Date().toISOString(),
//         });
//       }

//       alert(`${role} registration successful!`);
//       setLoading(false);
//       setSelectedRole(null);
      
//       // Reset form data
//       if (role === 'patient') setPatientData({First: '', Middle: '', Last: '', Email: '', Mobile: '', Password: '', ConfirmPassword: ''});
//       if (role === 'doctor') setDoctorData({ClinicName: '', LicenseNumber: '', Education: '', Email: '', First: '', Last: '', Locality: '', Mobile: '', Speciality: '', Password: '', ConfirmPassword: ''});
//       if (role === 'hospital') setHospitalData({HospitalName: '', RegistrationNumber: '', Email: '', Address: '', City: '', State: '', Mobile: '', Password: '', ConfirmPassword: ''});
      
//     } catch (error) {
//       setLoading(false);
//       if (error.code === 'auth/email-already-in-use') {
//         alert('Email is already registered');
//       } else {
//         alert('Registration failed: ' + error.message);
//       }
//     }
//   };

//   const InputField = ({ label, icon, type = 'text', name, ...props }) => {
//     const isPassword = type === 'password';
//     const fieldKey = `${selectedRole}-${name}`;
    
//     return (
//       <div style={{marginBottom: '16px'}}>
//         <label style={{display: 'block', fontSize: '14px', fontWeight: 600, color: '#374151', marginBottom: '8px'}}>{label}</label>
//         <div style={{position: 'relative'}}>
//           {icon && <div style={{position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF'}}>{icon}</div>}
//           <input 
//             {...props}
//             name={name}
//             type={isPassword ? (showPassword[fieldKey] ? 'text' : 'password') : type}
//             style={{width: '100%', padding: icon ? '12px 48px 12px 44px' : isPassword ? '12px 48px 12px 12px' : '12px', border: '2px solid #E5E7EB', borderRadius: '10px', fontSize: '14px', outline: 'none', transition: 'all 0.3s'}} 
//             onFocus={(e) => {e.target.style.borderColor = '#3B82F6'; e.target.style.boxShadow = '0 0 0 4px rgba(59,130,246,0.1)'}}
//             onBlur={(e) => {e.target.style.borderColor = '#E5E7EB'; e.target.style.boxShadow = 'none'}} 
//           />
//           {isPassword && (
//             <button
//               type="button"
//               onClick={() => setShowPassword(prev => ({...prev, [fieldKey]: !prev[fieldKey]}))}
//               style={{position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#9CA3AF', padding: '4px'}}
//               onMouseEnter={(e) => e.currentTarget.style.color = '#3B82F6'}
//               onMouseLeave={(e) => e.currentTarget.style.color = '#9CA3AF'}
//             >
//               {showPassword[fieldKey] ? (
//                 <svg style={{width: '20px', height: '20px'}} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
//                 </svg>
//               ) : (
//                 <svg style={{width: '20px', height: '20px'}} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                 </svg>
//               )}
//             </button>
//           )}
//         </div>
//       </div>
//     );
//   };

//   if (!selectedRole) {
//     return (
//       <div style={{minHeight: '100vh', background: 'linear-gradient(135deg, #EBF4FF 0%, #fff 50%, #E0F2FE 100%)', position: 'relative', overflow: 'hidden'}}>
//         <div style={{position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none'}}>
//           <div style={{position: 'absolute', top: '80px', left: '40px', width: '280px', height: '280px', background: '#BFDBFE', borderRadius: '50%', mixBlendMode: 'multiply', filter: 'blur(64px)', opacity: 0.3, animation: 'blob 7s infinite'}}></div>
//           <div style={{position: 'absolute', top: '160px', right: '40px', width: '280px', height: '280px', background: '#A5F3FC', borderRadius: '50%', mixBlendMode: 'multiply', filter: 'blur(64px)', opacity: 0.3, animation: 'blob 7s infinite 2s'}}></div>
//           <div style={{position: 'absolute', bottom: '-30px', left: '50%', width: '280px', height: '280px', background: '#99F6E4', borderRadius: '50%', mixBlendMode: 'multiply', filter: 'blur(64px)', opacity: 0.3, animation: 'blob 7s infinite 4s'}}></div>
//         </div>
//         <div style={{position: 'relative', zIndex: 10, maxWidth: '1200px', margin: '0 auto', padding: '64px 16px'}}>
//           <div style={{textAlign: 'center', marginBottom: '64px', animation: 'fadeIn 1s'}}>
//             <div style={{display: 'inline-block', marginBottom: '16px'}}>
//               <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '80px', height: '80px', background: 'linear-gradient(135deg, #3B82F6, #06B6D4)', borderRadius: '16px', boxShadow: '0 10px 25px rgba(0,0,0,0.15)', fontSize: '40px'}}>🏥</div>
//             </div>
//             <h1 style={{fontSize: '56px', fontWeight: 'bold', background: 'linear-gradient(to right, #2563EB, #06B6D4)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: '16px'}}>Welcome to HealthCare+</h1>
//             <p style={{fontSize: '20px', color: '#4B5563', maxWidth: '768px', margin: '0 auto', lineHeight: '1.75'}}>Join our comprehensive healthcare ecosystem designed for seamless collaboration between patients, doctors, and hospitals</p>
//           </div>
//           <div style={{maxWidth: '1280px', margin: '0 auto 48px'}}>
//             <h2 style={{fontSize: '30px', fontWeight: 600, textAlign: 'center', color: '#1F2937', marginBottom: '40px'}}>Choose Your Role</h2>
//             <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '32px'}}>
//               {[
//                 {role: 'patient', icon: '👤', color: '#60A5FA', gradient: 'linear-gradient(135deg, #60A5FA, #2563EB)', desc: 'Access quality healthcare services and manage your medical records'},
//                 {role: 'doctor', icon: '👨‍⚕️', color: '#22D3EE', gradient: 'linear-gradient(135deg, #22D3EE, #0891B2)', desc: 'Manage your practice and provide exceptional patient care'},
//                 {role: 'hospital', icon: '🏥', color: '#2DD4BF', gradient: 'linear-gradient(135deg, #2DD4BF, #14B8A6)', desc: 'Streamline operations and enhance patient experience'}
//               ].map(({role, icon, color, gradient, desc}) => (
//                 <div key={role} onClick={() => setSelectedRole(role)} style={{background: 'white', borderRadius: '24px', padding: '32px', boxShadow: '0 20px 50px rgba(0,0,0,0.1)', cursor: 'pointer', transition: 'all 0.5s', border: '2px solid transparent'}}
//                   onMouseEnter={(e) => {e.currentTarget.style.transform = 'translateY(-12px)'; e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.2)'; e.currentTarget.style.borderColor = color}}
//                   onMouseLeave={(e) => {e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.1)'; e.currentTarget.style.borderColor = 'transparent'}}>
//                   <div style={{display: 'flex', justifyContent: 'center', marginBottom: '24px'}}>
//                     <div style={{width: '96px', height: '96px', background: gradient, borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: `0 8px 20px ${color}40`, fontSize: '48px'}}>{icon}</div>
//                   </div>
//                   <h3 style={{fontSize: '24px', fontWeight: 'bold', color: '#1F2937', textAlign: 'center', marginBottom: '12px', textTransform: 'capitalize'}}>{role}</h3>
//                   <p style={{color: '#6B7280', textAlign: 'center', marginBottom: '24px'}}>{desc}</p>
//                   <div style={{display: 'flex', justifyContent: 'center'}}>
//                     <div style={{padding: '8px 24px', background: `${color}20`, color: color.replace('#', '').length === 6 ? color : '#2563EB', borderRadius: '9999px', fontWeight: 500}}>Get Started →</div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div style={{textAlign: 'center'}}>
//             <p style={{color: '#6B7280', fontSize: '18px'}}>Already have an account? <button style={{color: '#2563EB', fontWeight: 600, textDecoration: 'underline', background: 'none', border: 'none', cursor: 'pointer'}}>Login here</button></p>
//           </div>
//         </div>
//         <style>{`@keyframes blob{0%,100%{transform:translate(0,0) scale(1)}25%{transform:translate(20px,-50px) scale(1.1)}50%{transform:translate(-20px,20px) scale(0.9)}75%{transform:translate(50px,50px) scale(1.05)}}@keyframes fadeIn{from{opacity:0;transform:translateY(-20px)}to{opacity:1;transform:translateY(0)}}@keyframes slideUp{from{opacity:0;transform:translateY(50px)}to{opacity:1;transform:translateY(0)}}@keyframes spin{to{transform:rotate(360deg)}}`}</style>
//       </div>
//     );
//   }

//   const FormModal = ({ role, data, handleChange, color }) => (
//     <div style={{position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', zIndex: 9999, animation: 'fadeIn 0.3s', backdropFilter: 'blur(8px)'}}>
//       <div style={{background: 'white', borderRadius: '24px', boxShadow: '0 25px 50px rgba(0,0,0,0.3)', maxWidth: '650px', width: '100%', maxHeight: '90vh', overflowY: 'auto', animation: 'slideUp 0.4s'}}>
//         <div style={{background: `linear-gradient(to right, ${color})`, padding: '24px', borderTopLeftRadius: '24px', borderTopRightRadius: '24px', position: 'relative'}}>
//           <button onClick={() => setSelectedRole(null)} style={{position: 'absolute', top: '16px', left: '16px', color: 'white', background: 'rgba(255,255,255,0.2)', borderRadius: '9999px', padding: '8px', border: 'none', cursor: 'pointer'}} onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'} onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}>
//             <svg style={{width: '24px', height: '24px'}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>
//           </button>
//           <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
//             <div style={{width: '64px', height: '64px', background: 'white', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px', boxShadow: '0 8px 20px rgba(0,0,0,0.15)', fontSize: '32px'}}>
//               {role === 'patient' ? '👤' : role === 'doctor' ? '👨‍⚕️' : '🏥'}
//             </div>
//             <h2 style={{fontSize: '30px', fontWeight: 'bold', color: 'white', textTransform: 'capitalize'}}>{role} Registration</h2>
//             <p style={{color: 'rgba(255,255,255,0.9)', marginTop: '8px'}}>Fill in your details to get started</p>
//           </div>
//         </div>
//         <div style={{padding: '32px'}}>
//           {role === 'patient' && (<>
//             <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px'}}>
//               <InputField label="First Name" name="First" value={data.First} onChange={handleChange} />
//               <InputField label="Middle Name" name="Middle" value={data.Middle} onChange={handleChange} />
//             </div>
//             <InputField label="Last Name" name="Last" value={data.Last} onChange={handleChange} />
//             <InputField label="Email" name="Email" type="email" value={data.Email} onChange={handleChange} />
//             <InputField label="Mobile" name="Mobile" value={data.Mobile} onChange={handleChange} maxLength="10" />
//             <InputField label="Password" name="Password" type="password" value={data.Password} onChange={handleChange} />
//             <InputField label="Confirm Password" name="ConfirmPassword" type="password" value={data.ConfirmPassword} onChange={handleChange} />
//           </>)}
//           {role === 'doctor' && (<>
//             <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px'}}>
//               <InputField label="First Name" name="First" value={data.First} onChange={handleChange} />
//               <InputField label="Last Name" name="Last" value={data.Last} onChange={handleChange} />
//             </div>
//             <InputField label="Email" name="Email" type="email" value={data.Email} onChange={handleChange} />
//             <InputField label="Mobile" name="Mobile" value={data.Mobile} onChange={handleChange} maxLength="10" />
//             <InputField label="Clinic Name" name="ClinicName" value={data.ClinicName} onChange={handleChange} />
//             <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px'}}>
//               <InputField label="License" name="LicenseNumber" value={data.LicenseNumber} onChange={handleChange} />
//               <InputField label="Speciality" name="Speciality" value={data.Speciality} onChange={handleChange} />
//             </div>
//             <InputField label="Education" name="Education" value={data.Education} onChange={handleChange} />
//             <InputField label="Locality" name="Locality" value={data.Locality} onChange={handleChange} />
//             <InputField label="Password" name="Password" type="password" value={data.Password} onChange={handleChange} />
//             <InputField label="Confirm Password" name="ConfirmPassword" type="password" value={data.ConfirmPassword} onChange={handleChange} />
//           </>)}
//           {role === 'hospital' && (<>
//             <InputField label="Hospital Name" name="HospitalName" value={data.HospitalName} onChange={handleChange} />
//             <InputField label="Registration #" name="RegistrationNumber" value={data.RegistrationNumber} onChange={handleChange} />
//             <InputField label="Email" name="Email" type="email" value={data.Email} onChange={handleChange} />
//             <InputField label="Mobile" name="Mobile" value={data.Mobile} onChange={handleChange} maxLength="10" />
//             <InputField label="Address" name="Address" value={data.Address} onChange={handleChange} />
//             <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px'}}>
//               <InputField label="City" name="City" value={data.City} onChange={handleChange} />
//               <InputField label="State" name="State" value={data.State} onChange={handleChange} />
//             </div>
//             <InputField label="Password" name="Password" type="password" value={data.Password} onChange={handleChange} />
//             <InputField label="Confirm Password" name="ConfirmPassword" type="password" value={data.ConfirmPassword} onChange={handleChange} />
//           </>)}
//           <button onClick={() => handleSubmit(role)} disabled={loading} style={{width: '100%', marginTop: '24px', padding: '16px', borderRadius: '12px', fontWeight: 600, color: 'white', fontSize: '18px', boxShadow: '0 10px 25px rgba(0,0,0,0.15)', transition: 'all 0.3s', border: 'none', cursor: loading ? 'not-allowed' : 'pointer', background: loading ? '#9CA3AF' : `linear-gradient(to right, ${color})`}}
//             onMouseEnter={(e) => {if (!loading) {e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.2)'}}}
//             onMouseLeave={(e) => {e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.15)'}}>
//             {loading ? <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}><svg style={{animation: 'spin 1s linear infinite', height: '20px', width: '20px', marginRight: '12px'}} viewBox="0 0 24 24"><circle style={{opacity: 0.25}} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" /><path style={{opacity: 0.75}} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" /></svg>Registering...</span> : 'Complete Registration'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   if (selectedRole === 'patient') return <FormModal role="patient" data={patientData} handleChange={(e) => setPatientData(p => ({...p, [e.target.name]: e.target.value}))} color="#3B82F6, #2563EB" />;
//   if (selectedRole === 'doctor') return <FormModal role="doctor" data={doctorData} handleChange={(e) => setDoctorData(d => ({...d, [e.target.name]: e.target.value}))} color="#06B6D4, #0891B2" />;
//   if (selectedRole === 'hospital') return <FormModal role="hospital" data={hospitalData} handleChange={(e) => setHospitalData(h => ({...h, [e.target.name]: e.target.value}))} color="#14B8A6, #0D9488" />;
// };

// export default Register;

import React, { useState, useCallback } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Register = () => {
  const [selectedRole, setSelectedRole] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState({});
  
  const [patientData, setPatientData] = useState({
    First: '', Middle: '', Last: '', Email: '', Mobile: '', Password: '', ConfirmPassword: ''
  });
  
  const [doctorData, setDoctorData] = useState({
    ClinicName: '', LicenseNumber: '', Education: '', Email: '', First: '', Last: '', 
    Locality: '', Mobile: '', Speciality: '', Password: '', ConfirmPassword: ''
  });
  
  const [hospitalData, setHospitalData] = useState({
    HospitalName: '', RegistrationNumber: '', Email: '', Address: '', City: '', State: '', 
    Mobile: '', Password: '', ConfirmPassword: ''
  });

  const validateName = (name) => /^[a-zA-Z\s]*$/.test(name.trim());
  const validateEmail = (email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  const validatePassword = (password) => /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(password);
  const validateMobile = (mobile) => /^[6-9]\d{9}$/.test(mobile);

  const handleSubmit = async (role) => {
    let data = role === 'patient' ? patientData : role === 'doctor' ? doctorData : hospitalData;
    
    // Validation
    if (role === 'patient') {
      if (!data.First || !data.Middle || !data.Last) {
        toast.error('All name fields are required');
        return;
      }
      if (!validateName(data.First) || !validateName(data.Middle) || !validateName(data.Last)) {
        toast.error('Names should not contain numbers or special characters');
        return;
      }
    }
    
    if (!validateEmail(data.Email)) {
      toast.error('Please enter a valid email address');
      return;
    }
    
    if (!validateMobile(data.Mobile)) {
      toast.error('Please enter a valid 10-digit mobile number starting with 6-9');
      return;
    }
    
    if (!validatePassword(data.Password)) {
      toast.error('Password must be at least 8 characters with one letter, one number, and one special character');
      return;
    }
    
    if (data.Password !== data.ConfirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    setLoading(true);
    
    try {
      const { getAuth, createUserWithEmailAndPassword } = await import('firebase/auth');
      const { getDatabase, ref, set } = await import('firebase/database');
      const { app } = await import('../../../config/Firebase/firebase.config');
      
      const auth = getAuth(app);
      const fireDB = getDatabase(app);
      
      // Use the REAL email provided by user
      const email = data.Email;
      
      // Create user in Firebase Authentication with real email
      const userCredential = await createUserWithEmailAndPassword(auth, email, data.Password);
      const uid = userCredential.user.uid;

      if (role === 'patient') {
        await set(ref(fireDB, `users/${uid}`), {
          First: data.First,
          Middle: data.Middle,
          Last: data.Last,
          Email: email,
          Mobile: data.Mobile,
          uid: uid,
          role: 'patient',
          createdAt: new Date().toISOString(),
        });
      } else if (role === 'doctor') {
        await set(ref(fireDB, `doctor/${uid}`), {
          ClinicName: data.ClinicName,
          LicenseNumber: data.LicenseNumber,
          Education: data.Education,
          Email: email,
          First: data.First,
          Last: data.Last,
          Locality: data.Locality,
          Mobile: data.Mobile,
          Speciality: data.Speciality,
          uid: uid,
          role: 'doctor',
          createdAt: new Date().toISOString(),
        });
      } else if (role === 'hospital') {
        await set(ref(fireDB, `hospitals/${uid}`), {
          HospitalName: data.HospitalName,
          RegistrationNumber: data.RegistrationNumber,
          Email: email,
          Address: data.Address,
          City: data.City,
          State: data.State,
          Mobile: data.Mobile,
          uid: uid,
          role: 'hospital',
          createdAt: new Date().toISOString(),
        });
      }

      toast.success(`${role.charAt(0).toUpperCase() + role.slice(1)} registration successful!`);
      
      // Auto-login after registration
      try {
        // Store in localStorage
        localStorage.setItem('userId', uid);
        localStorage.setItem('userRole', role);
        localStorage.setItem('userEmail', email);
        localStorage.setItem('userName', 
          role === 'patient' ? `${data.First} ${data.Last}` :
          role === 'doctor' ? `Dr. ${data.First} ${data.Last}` :
          data.HospitalName || data.ClinicName
        );
        
        // Send email verification (optional)
        // await sendEmailVerification(auth.currentUser);
        // toast.info('Verification email sent. Please verify your email.');
        
        // Redirect based on role
        setTimeout(() => {
          if (role === 'patient') {
            window.location.href = '/patient-dashboard';
          } else if (role === 'doctor') {
            window.location.href = '/doctor-dashboard';
          } else if (role === 'hospital') {
            window.location.href = '/hospital-dashboard';
          }
        }, 2000);
        
      } catch (authError) {
        console.error('Auto-login error:', authError);
      }
      
      setLoading(false);
      setSelectedRole(null);
      
      // Reset form data
      if (role === 'patient') setPatientData({First: '', Middle: '', Last: '', Email: '', Mobile: '', Password: '', ConfirmPassword: ''});
      if (role === 'doctor') setDoctorData({ClinicName: '', LicenseNumber: '', Education: '', Email: '', First: '', Last: '', Locality: '', Mobile: '', Speciality: '', Password: '', ConfirmPassword: ''});
      if (role === 'hospital') setHospitalData({HospitalName: '', RegistrationNumber: '', Email: '', Address: '', City: '', State: '', Mobile: '', Password: '', ConfirmPassword: ''});
      
    } catch (error) {
      setLoading(false);
      if (error.code === 'auth/email-already-in-use') {
        toast.error('Email is already registered. Please use Forgot Password or try a different email.');
      } else if (error.code === 'auth/weak-password') {
        toast.error('Password is too weak. Please use a stronger password.');
      } else if (error.code === 'auth/invalid-email') {
        toast.error('Invalid email address format.');
      } else {
        toast.error('Registration failed: ' + error.message);
      }
    }
  };

  const InputField = useCallback(({ label, type = 'text', name, value, onChange, maxLength, required = true }) => {
    const isPassword = type === 'password';
    const fieldKey = `${selectedRole}-${name}`;
    
    const handlePasswordToggle = () => {
      setShowPassword(prev => ({
        ...prev,
        [fieldKey]: !prev[fieldKey]
      }));
    };

    return (
      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', fontSize: '14px', fontWeight: 600, color: '#374151', marginBottom: '8px' }}>
          {label} {required && <span style={{ color: 'red' }}>*</span>}
        </label>
        <div style={{ position: 'relative' }}>
          <input 
            name={name}
            type={isPassword ? (showPassword[fieldKey] ? 'text' : 'password') : type}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            required={required}
            style={{
              width: '100%',
              padding: isPassword ? '12px 48px 12px 12px' : '12px',
              border: '2px solid #E5E7EB',
              borderRadius: '10px',
              fontSize: '14px',
              outline: 'none'
            }} 
          />
          {isPassword && (
            <button
              type="button"
              onClick={handlePasswordToggle}
              style={{
                position: 'absolute',
                right: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#9CA3AF',
                padding: '4px'
              }}
            >
              {showPassword[fieldKey] ? 'Hide' : 'Show'}
            </button>
          )}
        </div>
      </div>
    );
  }, [selectedRole, showPassword]);

  // Role selection screen
  if (!selectedRole) {
    return (
      <div style={{ minHeight: '100vh', backgroundColor: '#f3f4f6', padding: '20px' }}>
        <ToastContainer />
        <div style={{ maxWidth: '1200px', margin: '0 auto', paddingTop: '40px' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <h1 style={{ fontSize: '36px', fontWeight: 'bold', color: '#1F2937', marginBottom: '16px' }}>
              Welcome to TrustYou Doctor
            </h1>
            <p style={{ fontSize: '16px', color: '#4B5563', maxWidth: '768px', margin: '0 auto' }}>
              Join our comprehensive healthcare ecosystem
            </p>
          </div>
          
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 600, textAlign: 'center', color: '#1F2937', marginBottom: '30px' }}>
              Choose Your Role
            </h2>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', flexWrap: 'wrap' }}>
              {[
                {role: 'patient', icon: '👤', color: '#3B82F6', desc: 'Access healthcare services'},
                {role: 'doctor', icon: '👨‍⚕️', color: '#06B6D4', desc: 'Manage your practice'},
                {role: 'hospital', icon: '🏥', color: '#10B981', desc: 'Streamline operations'}
              ].map(({role, icon, color, desc}) => (
                <div 
                  key={role}
                  onClick={() => setSelectedRole(role)}
                  style={{
                    width: '220px',
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '30px 20px',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    cursor: 'pointer',
                    textAlign: 'center',
                    border: `2px solid ${color}`,
                    transition: 'all 0.3s'
                  }}
                >
                  <div style={{ fontSize: '48px', marginBottom: '16px' }}>{icon}</div>
                  <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1F2937', marginBottom: '8px', textTransform: 'capitalize' }}>
                    {role}
                  </h3>
                  <p style={{ color: '#6B7280', marginBottom: '20px' }}>{desc}</p>
                  <button 
                    style={{
                      backgroundColor: color,
                      color: 'white',
                      border: 'none',
                      padding: '10px 20px',
                      borderRadius: '8px',
                      fontWeight: 500,
                      cursor: 'pointer'
                    }}
                  >
                    Register
                  </button>
                </div>
              ))}
            </div>
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <p style={{ color: '#6B7280' }}>
              Already have an account? <a href="/login" style={{ color: '#2563EB', fontWeight: 600 }}>Login here</a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  const renderForm = () => {
    let data, color, handleChange;
    
    switch(selectedRole) {
      case 'patient':
        data = patientData;
        color = '#3B82F6';
        handleChange = (e) => {
          setPatientData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
          }));
        };
        break;
      case 'doctor':
        data = doctorData;
        color = '#06B6D4';
        handleChange = (e) => {
          setDoctorData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
          }));
        };
        break;
      case 'hospital':
        data = hospitalData;
        color = '#10B981';
        handleChange = (e) => {
          setHospitalData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
          }));
        };
        break;
      default:
        return null;
    }

    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        zIndex: 1000
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          maxWidth: '600px',
          width: '100%',
          maxHeight: '90vh',
          overflowY: 'auto'
        }}>
          <div style={{
            backgroundColor: color,
            padding: '20px',
            borderTopLeftRadius: '12px',
            borderTopRightRadius: '12px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: 'white', textTransform: 'capitalize' }}>
              {selectedRole} Registration
            </h2>
            <button 
              onClick={() => setSelectedRole(null)}
              style={{
                background: 'rgba(255,255,255,0.2)',
                border: 'none',
                color: 'white',
                cursor: 'pointer',
                padding: '8px',
                borderRadius: '4px',
                fontSize: '20px'
              }}
            >
              ×
            </button>
          </div>
          
          <div style={{ padding: '30px' }}>
            {selectedRole === 'patient' && (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <InputField label="First Name" name="First" value={data.First} onChange={handleChange} />
                  <InputField label="Middle Name" name="Middle" value={data.Middle} onChange={handleChange} />
                </div>
                <InputField label="Last Name" name="Last" value={data.Last} onChange={handleChange} />
                <InputField label="Email Address" name="Email" type="email" value={data.Email} onChange={handleChange} />
                <InputField 
                  label="Mobile Number" 
                  name="Mobile" 
                  type="tel"
                  value={data.Mobile} 
                  onChange={handleChange} 
                  maxLength="10" 
                />
                <InputField label="Password" name="Password" type="password" value={data.Password} onChange={handleChange} />
                <InputField label="Confirm Password" name="ConfirmPassword" type="password" value={data.ConfirmPassword} onChange={handleChange} />
              </>
            )}
            
            {selectedRole === 'doctor' && (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <InputField label="First Name" name="First" value={data.First} onChange={handleChange} />
                  <InputField label="Last Name" name="Last" value={data.Last} onChange={handleChange} />
                </div>
                <InputField label="Email Address" name="Email" type="email" value={data.Email} onChange={handleChange} />
                <InputField 
                  label="Mobile Number" 
                  name="Mobile" 
                  type="tel"
                  value={data.Mobile} 
                  onChange={handleChange} 
                  maxLength="10" 
                />
                <InputField label="Clinic Name" name="ClinicName" value={data.ClinicName} onChange={handleChange} />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <InputField label="License Number" name="LicenseNumber" value={data.LicenseNumber} onChange={handleChange} />
                  <InputField label="Speciality" name="Speciality" value={data.Speciality} onChange={handleChange} />
                </div>
                <InputField label="Education" name="Education" value={data.Education} onChange={handleChange} />
                <InputField label="Locality" name="Locality" value={data.Locality} onChange={handleChange} />
                <InputField label="Password" name="Password" type="password" value={data.Password} onChange={handleChange} />
                <InputField label="Confirm Password" name="ConfirmPassword" type="password" value={data.ConfirmPassword} onChange={handleChange} />
              </>
            )}
            
            {selectedRole === 'hospital' && (
              <>
                <InputField label="Hospital Name" name="HospitalName" value={data.HospitalName} onChange={handleChange} />
                <InputField label="Registration Number" name="RegistrationNumber" value={data.RegistrationNumber} onChange={handleChange} />
                <InputField label="Email Address" name="Email" type="email" value={data.Email} onChange={handleChange} />
                <InputField 
                  label="Mobile Number" 
                  name="Mobile" 
                  type="tel"
                  value={data.Mobile} 
                  onChange={handleChange} 
                  maxLength="10" 
                />
                <InputField label="Address" name="Address" value={data.Address} onChange={handleChange} />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <InputField label="City" name="City" value={data.City} onChange={handleChange} />
                  <InputField label="State" name="State" value={data.State} onChange={handleChange} />
                </div>
                <InputField label="Password" name="Password" type="password" value={data.Password} onChange={handleChange} />
                <InputField label="Confirm Password" name="ConfirmPassword" type="password" value={data.ConfirmPassword} onChange={handleChange} />
              </>
            )}
            
            <button 
              onClick={() => handleSubmit(selectedRole)}
              disabled={loading}
              style={{
                width: '100%',
                marginTop: '24px',
                padding: '14px',
                borderRadius: '8px',
                fontWeight: 600,
                color: 'white',
                fontSize: '16px',
                border: 'none',
                cursor: loading ? 'not-allowed' : 'pointer',
                backgroundColor: loading ? '#9CA3AF' : color
              }}
            >
              {loading ? 'Registering...' : 'Complete Registration'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <ToastContainer />
      {renderForm()}
    </>
  );
};

export default Register;